var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { USER_PROFILE_DATA } from "../../../api/url";
import { CalanderIconSVG } from "../../../assets/customIcons";
import { CrossIcon } from "../../../assets/images";
import { MuiIconButton, MuiRightDrawer } from "../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiBox } from "../../../components";
import { APISchema, LOCAL_STORAGE_KEYS } from "../../../constants";
import { resetState, setReducerState, setState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { statusListGet } from "../../stockAdjustment/apiCall";
import { getServiceAdvisorListAPICall, getTechnicianListAPICall, getWarehouseListAPICall, spareIssuePagingAPICall } from "../services/apiCalls";
import { defaultState, SpareIssuesKeys } from "../services/entity";
export var FilterComponent = function (props) {
    var _getLocalStorageItem, _userData$data3, _userData$data4;
    var isFilterOpen = props.isFilterOpen, setFilterOpen = props.setFilterOpen, selectedView = props.selectedView;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var dispatch = useDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var viewType = getLocalStorageItem(LOCAL_STORAGE_KEYS.PAGING_VIEW_TYPE);
    var organizationId = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var handleApplyClick = function (event, values) {
        var _getLocalStorageItem$, _getLocalStorageItem2, _values$Status, _userData$data, _values$ServiceAdviso, _values$WarehouseId, _values$TechnicianId, _values$StartDocDate, _values$EndDocDate, _req$Status, _userData$data2, _req$Status2;
        var req = {
            Branches: [(_getLocalStorageItem$ = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.OrganizationId) !== null && _getLocalStorageItem$ !== void 0 ? _getLocalStorageItem$ : undefined],
            Status: values === null || values === void 0 || (_values$Status = values.Status) === null || _values$Status === void 0 ? void 0 : _values$Status.map(function (item) { return item; }),
            ServiceAdvisorId: viewType === 1 ? userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId : (_values$ServiceAdviso = values === null || values === void 0 ? void 0 : values.ServiceAdvisorId) !== null && _values$ServiceAdviso !== void 0 ? _values$ServiceAdviso : undefined,
            WarehouseId: (_values$WarehouseId = values === null || values === void 0 ? void 0 : values.WarehouseId) !== null && _values$WarehouseId !== void 0 ? _values$WarehouseId : undefined,
            TechnicianId: (_values$TechnicianId = values === null || values === void 0 ? void 0 : values.TechnicianId) !== null && _values$TechnicianId !== void 0 ? _values$TechnicianId : undefined,
            StartDocDate: (_values$StartDocDate = values === null || values === void 0 ? void 0 : values.StartDocDate) !== null && _values$StartDocDate !== void 0 ? _values$StartDocDate : undefined,
            EndDocDate: (_values$EndDocDate = values === null || values === void 0 ? void 0 : values.EndDocDate) !== null && _values$EndDocDate !== void 0 ? _values$EndDocDate : undefined
        };
        dispatch(setReducerState({
            key: SpareIssuesKeys.Paging,
            value: true
        }));
        dispatch(setState({
            key: "filterValue",
            value: req
        }));
        if (selectedView === "My Spare Issue")
            spareIssuePagingAPICall({
                request: _objectSpread(_objectSpread(_objectSpread({}, req), {}, {
                    Status: req === null || req === void 0 || (_req$Status = req.Status) === null || _req$Status === void 0 ? void 0 : _req$Status.map(function (item) { return item === null || item === void 0 ? void 0 : item.Name; })
                }, defaultState), {}, {
                    IdentityId: userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.IdentityId
                })
            });
        if (selectedView === "All Spare Issue")
            spareIssuePagingAPICall({
                request: _objectSpread(_objectSpread({}, req), {}, {
                    Status: req === null || req === void 0 || (_req$Status2 = req.Status) === null || _req$Status2 === void 0 ? void 0 : _req$Status2.map(function (item) { return item === null || item === void 0 ? void 0 : item.Name; })
                }, defaultState)
            });
        setFilterOpen(false);
    };
    var formData = [{
            type: FormItemTypes.Custom,
            name: 'Header',
            label: '',
            element: function () { /*#__PURE__*/ return React.createElement(MuiBox, null, /*#__PURE__*/ React.createElement(Grid, {
                container: true,
                spacing: 5,
                paddingTop: IS_DESKTOP ? 8 : 0,
                paddingBottom: 3
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 10
            }, /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontSize: 'xxl',
                    fontWeight: 'strong'
                }
            }, t("Filters")), /*#__PURE__*/ React.createElement(Typography, {
                fontSize: 'base',
                fontWeight: 'normal',
                color: 'secondary.main'
            }, t("Apply filters to table data."))), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 2
            }, /*#__PURE__*/ React.createElement(MuiIconButton, {
                onClick: function () { return setFilterOpen(false); },
                style: {
                    justifyContent: 'flex-end'
                },
                id: "cancelButton"
            }, /*#__PURE__*/ React.createElement("img", {
                id: "crossIconBtn",
                src: CrossIcon
            }))))); },
            value: null,
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'FormContainer',
            label: '',
            value: null,
            columnSize: 12,
            sx: {
                marginBottom: '20px',
                flexGrow: 1,
                overflowY: 'auto',
                padding: '16px'
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'WarehouseId',
                    label: 'Warehouse',
                    displayExpr: "Name",
                    valueExpr: "id",
                    getListData: getWarehouseListAPICall,
                    labelTypographyProps: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.dark'
                    },
                    apiRequest: {
                        TenantId: organizationId
                    },
                    value: null,
                    columnSize: 12
                }, viewType === 1 ? {
                    type: FormItemTypes.TextInput,
                    name: 'ServiceAdvisorId',
                    label: 'Service Advisor',
                    disabled: true,
                    labelTypographyProps: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.dark'
                    },
                    value: "".concat(userData === null || userData === void 0 || (_userData$data3 = userData.data) === null || _userData$data3 === void 0 ? void 0 : _userData$data3.GivenName, " ").concat(userData === null || userData === void 0 || (_userData$data4 = userData.data) === null || _userData$data4 === void 0 ? void 0 : _userData$data4.FamilyName),
                    columnSize: 12
                } : {
                    type: FormItemTypes.SearchSelect,
                    name: 'ServiceAdvisorId',
                    label: 'Service Advisor',
                    getListData: getServiceAdvisorListAPICall,
                    apiRequest: {
                        BranchId: organizationId
                    },
                    labelTypographyProps: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.dark'
                    },
                    apiKey: SpareIssuesKeys.ServiceAdvisorList,
                    getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.FirstName, " ").concat(option === null || option === void 0 ? void 0 : option.LastName); },
                    value: null,
                    displayExpr: "Name",
                    valueExpr: "IdentityId",
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'TechnicianId',
                    label: 'Technician',
                    getListData: getTechnicianListAPICall,
                    labelTypographyProps: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.dark'
                    },
                    apiRequest: {
                        WorkingOrganizationId: organizationId
                    },
                    getOptionLabel: function (option) { return "".concat(option === null || option === void 0 ? void 0 : option.FirstName, " ").concat(option === null || option === void 0 ? void 0 : option.LastName); },
                    value: null,
                    displayExpr: "Name",
                    valueExpr: "id",
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Status',
                    label: 'Status',
                    multiple: true,
                    getListData: statusListGet,
                    apiRequest: {
                        SystemName: APISchema.SpareIssues
                    },
                    apiKey: SpareIssuesKeys.Status,
                    valueExpr: "id",
                    displayExpr: "Name",
                    labelTypographyProps: {
                        fontSize: 'base',
                        fontWeight: 'medium',
                        color: 'secondary.dark'
                    },
                    value: null,
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'SelectSpareIssueDate',
                    label: 'Spare Issue Data',
                    value: null,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'SelectSpareIssueDateTypography',
                            label: 'Spare Issue Date',
                            value: null,
                            labelTypographyProps: {
                                fontSize: 'base',
                                fontWeight: 'medium',
                                color: 'secondary.dark'
                            },
                            columnSize: 12
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'StartDocDate',
                            placeholder: "From",
                            value: null,
                            slotProps: {
                                inputAdornment: {
                                    position: 'start'
                                }
                            },
                            slots: {
                                openPickerIcon: CalanderIconSVG,
                                clearButton: function () { return null; }
                            },
                            columnSize: 6
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'EndDocDate',
                            placeholder: "To",
                            value: null,
                            slotProps: {
                                inputAdornment: {
                                    position: 'start'
                                }
                            },
                            slots: {
                                openPickerIcon: CalanderIconSVG,
                                clearButton: function () { return null; }
                            },
                            columnSize: 6
                        }],
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            label: '',
            value: null,
            spacing: 0,
            sx: {
                bottom: 0,
                justifyContent: 'space-between',
                backgroundColor: 'white',
                width: {
                    xs: '75%',
                    sm: '400px'
                },
                position: 'fixed',
                right: 0,
                zIndex: 1000,
                paddingBottom: '16px',
                borderTop: "1px solid",
                borderColor: 'secondary.200'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Reset',
                    label: '',
                    children: 'Reset',
                    value: null,
                    onClick: function () {
                        dispatch(resetState(["filterValue"]));
                        dispatch(setReducerState({
                            key: 'filterValue',
                            value: true
                        }));
                        return 'reset';
                    },
                    xs: 6,
                    sm: 6,
                    md: 6,
                    lg: 6
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'saveButton',
                    label: '',
                    value: null,
                    xs: 6,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'Cancel',
                            label: '',
                            children: 'Cancel',
                            value: null,
                            xs: 6,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            onClick: function () {
                                setFilterOpen(false);
                            },
                            sx: {
                                border: '1px solid',
                                borderColor: 'secondary.200',
                                marginLeft: '2px'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Apply',
                            label: '',
                            children: 'Apply',
                            value: null,
                            onClick: handleApplyClick,
                            xs: 6,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            sx: {
                                border: '1px solid',
                                borderColor: 'secondary.200',
                                backgroundColor: 'primary.500',
                                color: '#FFFFFF',
                                ":hover": {
                                    color: 'primary.500'
                                }
                            }
                        }]
                }],
            columnSize: 12
        }];
    var getAppliedFilterData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, {
                    data: crud['filterValue'],
                    success: true
                }];
        });
    }); };
    return /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: isFilterOpen,
        onClose: function () { return setFilterOpen(false); },
        width: "440px",
        sx: {
            width: {
                xs: '250px',
                sm: '400px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        getFormAPI: getAppliedFilterData,
        getKey: crud['filterValue'],
        mode: "edit",
        formProps: {
            p: 1.5,
            pl: 3
        }
    }));
};
